import 'owl.carousel';

export default function () {
  $(document).ready(function () {
    $('.owl-carousel').owlCarousel({
      nav: true,
      navText: ['<i class="fas fa-chevron-left">', '<i class="fas fa-chevron-right">'],
      margin: 50,
      loop: true,
      autoplay: true,
      stagePadding: 30,
      responsive: {
        // breakpoint from 0 up
        0: {
          items: 1,
        },
        // breakpoint from 480 up
        480: {
          items: 2,
        },
        // breakpoint from 768 up
        768: {
          items: 3,
        },
      },
    });
  });
}



// WEBPACK FOOTER //
// ./scripts/util/owlcarousel.js